import Question from '../util/question'
import { gameState } from '../util/game_state'
import PlayButton from '../util/play_button'

up.compiler('[video-multiple-choice]', (element, { name, buttonMode, skipToSolution, completeSlideUrl }) => {
  const multipleChoice = new Question(element, name)
  const questionVideo = element.querySelector('[question--question-video]')
  const solutionVideo = element.querySelector('[question--solution-video]')
  const choices = element.querySelector('[question--choices]')
  const startButton = element.querySelector('[question--start-button]')
  const submitButton = element.querySelector('[question--submit-button]')
  const replayButton = element.querySelector('[question--replay-button]')

  let submitted = false

  up.on(questionVideo, 'ended', onQuestionVideoEnded)
  up.on(submitButton, 'click', onClickSubmit)
  up.on(element, 'click', '[question--choice-button]', onClickChoice)
  up.on(replayButton, 'click', replayVideo)
  gameState.submit.register(onClickSubmit)

  const videoPlayButton = new PlayButton(questionVideo, startButton)
  videoPlayButton.connect()

  if (skipToSolution) {
    submit()
    showChoicesAndAdjustControls()
    multipleChoice.skipToSolution()
    showAndPlaySolutionVideo()
  }

  function onQuestionVideoEnded() {
    const wasHidden = showChoicesAndAdjustControls()

    if (wasHidden) {
      up.emit(questionVideo, 'app:playback:ended')
    }
  }

  function onAnyPlaybackEnded(event, playbackElement) {
    const { playbackIndex } = playbackElement.dataset

    if (playbackIndex) {
      const nextIndex = `${parseInt(playbackIndex) + 1}`

      if (questionVideo.dataset.playbackIndex !== nextIndex) return

      if (up.element.isVisible(questionVideo)) {
        videoPlayButton.play()
      } else {
        // Should have played question video, but it was not visible.
        // We skip over it so the potentially next (or later) element can play.
        up.emit(questionVideo, 'app:playback:ended')
      }
    }
  }

  function showChoicesAndAdjustControls() {
    const wasHidden = choices.hasAttribute('hidden')

    choices.removeAttribute('hidden')
    replayButton.removeAttribute('hidden')
    startButton.setAttribute('hidden', true)
    questionVideo.controls = false

    if (!buttonMode) {
      submitButton.removeAttribute('hidden')
    }

    return wasHidden
  }

  async function onClickChoice(_event, button) {
    checkChoice(button.dataset.checkboxId)
    onClickSubmit()
  }

  function checkChoice(answerId) {
    const choiceCheckbox = choices.querySelector(`[id="${answerId}"]`)
    choiceCheckbox.checked = true
  }

  async function onClickSubmit() {
    submit()
    showChoicesAndAdjustControls()

    if (completeSlideUrl) {
      await up.request(completeSlideUrl, { method: 'POST' })
    }
    multipleChoice.checkAnswers()
    showAndPlaySolutionVideo()
  }

  function submit() {
    submitButton.remove()
    gameState.stopGame()
    submitted = true
  }

  function showAndPlaySolutionVideo() {
    questionVideo.setAttribute('hidden', true)
    replayButton.setAttribute('hidden', true)
    solutionVideo.removeAttribute('hidden')

    solutionVideo.play().catch(() => {
      // User probably did not interact with the page yet. Browsers do not allow video playback in that case,
      // and there is nothing we can do except silencing the error.
    })
  }

  function replayVideo() {
    replayButton.setAttribute('hidden', true)
    questionVideo.controls = true
    questionVideo.play()
  }

  function onDestroy() {
    gameState.submit.unregister(onClickSubmit)
    videoPlayButton.disconnect()
    if (!submitted) {
      gameState.stopGame()
    }
  }

  return [
    up.on('app:playback:ended', onAnyPlaybackEnded),
    onDestroy,
  ]
})
